import { Stack } from '@mui/material';
import { VigoTypography } from 'src/@vigo/vigo-typography';
import { useAuth } from 'react-oidc-context';
import { useGetUserProfileQuery } from 'src/queries/services/identity';
import { useVigoTranslation } from 'src/@core/hooks/useVigoTranslation';

const userProfileQueryParams = {
  refetchOnWindowFocus: false,
  refetchOnMount: true,
  staleTime: Infinity
};

const WelcomeMessage = () => {
  const auth = useAuth();
  const user = auth.user;
  const loggedInUserId = user?.profile.tenantUserId as string;
  const { t } = useVigoTranslation();

  const { data: userData } = useGetUserProfileQuery(loggedInUserId, userProfileQueryParams);

  const determineGreeting = () => {
    const hours = new Date().getHours();

    return hours < 12 ? t('Good Morning') : hours < 18 ? t('Good Afternoon') : t('Good Evening');
  };

  return (
    <Stack direction="column" sx={{ paddingLeft: '20px' }}>
      <VigoTypography
        disableTranslation
        value={`${determineGreeting()}, ${userData?.userProfile?.forname ? userData?.userProfile?.forname + '.' : ''}`}
        sx={{
          fontSize: '2.143rem',
          fontWeight: 600
        }}
      />
      <VigoTypography
        value="Things are looking great. Enjoy your day."
        sx={{
          fontSize: '1.286rem',
          fontWeight: 600
        }}
      />
    </Stack>
  );
};

export default WelcomeMessage;
